import { z } from 'zod';
import { catalogs } from '../config/catalogs';
import { resolveSpeciesId } from '../config/loadGameConfig';

// Build strips documentation fields, so validate only the fields this display reads.
// Do not parse the full source schema or pass this reference to simulation config.
const Reference = z.object({
  id: z.string(), common_name: z.string(),
  behavior: z.object({
    social: z.object({ type: z.string(), min_group: z.number(), male_ratio: z.number() }),
    activity: z.string(),
  }),
});
/** Source-catalog reference only. Never passed into the simulation config. */
export function speciesReference(species: string) {
  const id = resolveSpeciesId(species.toLowerCase().replace(/[ -]+/g, '_'));
  const raw = catalogs().species.find(r => (r as { id?: string }).id === id);
  if (!raw) return null;
  const record = Reference.parse(raw);
  const social = record.behavior.social;
  return {
    name: record.common_name,
    social: social.type,
    minGroup: social.min_group,
    maleRatioPct: social.male_ratio * 100,
    activity: record.behavior.activity,
  };
}
